import ViewMyOrders from "../components/orders/ViewMyOrders";

export default function MyOrdersPage() {
  return <ViewMyOrders />;
}
